import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=37b1d4cc&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"
import style0 from "./Todo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b1d4cc')) {
      api.createRecord('37b1d4cc', component.options)
    } else {
      api.reload('37b1d4cc', component.options)
    }
    module.hot.accept("./Todo.vue?vue&type=template&id=37b1d4cc&", function () {
      api.rerender('37b1d4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/todo/Todo.vue"
export default component.exports